import { isServer } from './is-server';
/**
 * 获取当前window实例
 * @ignore
 */
export function getWindow() {
    return isServer ? global : window;
}
/**
 * @ignore
 */
export function setWindowInstance(key, value) {
    getWindow()[key] = value;
}
